import { Avatar, Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { PurpleOutlinedAlert } from 'Images';

export const TextWithIcon = ({
  text,
  icon,
}: {
  text: string;
  icon?: string;
}) => {
  const isDesktop = useIsDesktop();
  return (
    <Stack
      alignItems={isDesktop ? 'center' : 'flex-start'}
      gap={'8px'}
      flexDirection={'row'}
      m={isDesktop ? '10px 0 0' : '10px 0'}
    >
      <Avatar
        sx={{ width: '24px', height: '24px' }}
        alt=''
        src={icon || PurpleOutlinedAlert}
      />
      <Typography variant={isDesktop ? 'body6' : 'body7'} role='note'>
        {text}
      </Typography>
    </Stack>
  );
};
